import { useQuery } from '@tanstack/react-query';
import { API_HOST_NAME } from '@/config';
import { CONFIG, UPDATE_COMPANY } from '@/constants/API';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import storage from '@/utils/storage';

export const getConfig = async () => {
  storage.setItem('IS_SERVER_TIMEOUT', false);
  storage.setItem('IS_SERVER_OFFLINE', false);
  const hostName = window.location.hostname;
  const verifiedHostName = hostName.includes('www') ? hostName.split('www.')[1] : hostName;

  const host = process.env.NODE_ENV === 'development' ? API_HOST_NAME : verifiedHostName;
  const url = `${CONFIG}/${host}/web`;
  return await axios.get(url);
};

export const getCompany = async (companyId: string) => {
  try {
    const data = await axios.get(`${UPDATE_COMPANY}${companyId}`);
    return data.data;
  } catch (error) {}
};

type UpdateConfigQueryFnType = typeof getConfig;
type UpdateLocationQueryFnType = typeof getCompany;

type UseUpdateLocationOptions = {
  companyId: string;
  config?: QueryConfig<UpdateLocationQueryFnType>;
};

type UseGetConfigOptions = {
  config?: QueryConfig<UpdateLocationQueryFnType>;
};

export const useConfig = ({ config }: UseGetConfigOptions) =>
  useQuery<ExtractFnReturnType<UpdateConfigQueryFnType>>({
    queryKey: ['comapany-config'],
    queryFn: async () => await getConfig(),
    ...config,
  });

export const useCompany = ({ companyId, config }: UseUpdateLocationOptions) =>
  useQuery<ExtractFnReturnType<UpdateConfigQueryFnType>>({
    ...config,
    queryKey: ['company', companyId],
    queryFn: async () => await getCompany(companyId),
  });
